import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar, LetterAvatar, Text } from '../../../../../components';

const AvatarNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 100%;
`;

const AvatarCellRenderer = ({ data }) => {
  if (!data) return null;

  return (
    <AvatarNameContainer>
      {data.picture ? (
        <Avatar width={24} height={24} src={data.picture} />
      ) : (
        <LetterAvatar size={24} name={data.email} />
      )}
      <Text>{data.name}</Text>
    </AvatarNameContainer>
  );
};

AvatarCellRenderer.propTypes = {
  data: PropTypes.shape({
    picture: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string
  })
};

export { AvatarCellRenderer };
